import '../../../style.css';

import { InputAdornment } from '@material-ui/core';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';
import PureRenderMixin from '../../../mixins/pure-render-mixin';
import Field from './field';

// First, you need to create the `numberMask` with your desired configurations

const IntegerInput = (props) => {
  const { prefix, min, max, dataTestId, ...other } = props;
  return (
    // don't change, as this will break tblConfig currently :(
    <NumericFormat
      date-testid={dataTestId}
      type="tel"
      thousandSeparator={false}
      decimalScale={0}
      prefix={prefix}
      isAllowed={(values) => {
        if (min !== null && values.floatValue < min) {
          return false;
        }
        if (max !== null && values.floatValue > max) {
          return false;
        }
        return true;
      }}
      {...other}
      className={`text-right ${other.className}`}
    />
  );
};

IntegerInput.propTypes = {
  inputRef: PropTypes.func.isRequired
};

export default createReactClass({
  displayName: 'field-integer',
  mixins: [PureRenderMixin],

  getDefaultProps() {
    return {
      prefix: '',
      postfix: '',
      parentStyle: {},
      postfixStyle: {},
      max: null,
      min: null,
      newUx: false
    };
  },

  newUxOnChange(value: string) {
    const { max, min } = this.props;
    const v = parseInt(value.toString().replace(/[^\d.-]/g, ''));
    if (!!v) {
      if (max != null && v > max) {
        this.props.onChange(max);
        return;
      }

      if (min != null && v < min) {
        this.props.onChange(min);
        return;
      }
    }
    this.props.onChange(value);
  },

  onChange(e) {
    this.newUxOnChange(e.target.value);
  },
  onBlur(value: string) {
    const { max, min } = this.props;
    const v = parseInt(value.toString().replace(/[^\d.-]/g, ''));
    if (!!v) {
      if (max != null && v > max) {
        this.props.onBlur(max);
        return;
      }

      if (min != null && v < min) {
        this.props.onBlur(min);
        return;
      }
    }
    this.props.onBlur?.(value);
  },

  render() {
    const { prefix, postfix, readOnly, value, label, min, max, newUx, ...other } = this.props;
    if (readOnly) {
      return (
        <div className="bz-read-only">
          <div>{label}</div>
          <div>
            <span>{prefix}</span>
            <span>{value}</span>
            <span>{postfix}</span>
          </div>
        </div>
      );
    } else {
      let startAdornment = !!prefix ? (
        <InputAdornment position="start">{prefix}</InputAdornment>
      ) : null;

      let endAdornment = !!postfix ? (
        <InputAdornment position="end">{postfix}</InputAdornment>
      ) : null;
      return (
        <Field
          autocomplete="off"
          managed={true}
          liveOnChange={true}
          label={label}
          {...{ value, ...other }}
          endAdornment={endAdornment}
          startAdornment={startAdornment}
          inputComponent={IntegerInput}
          onChange={newUx ? this.newUxOnChange : this.onChange}
          onBlur={this.onBlur}
          spreadToInputComponent={{ min, max }}
          placeholder=""
        />
      );
    }
  }
});
